import { render, staticRenderFns } from "./inputFile.vue?vue&type=template&id=53509ea2&"
import script from "./inputFile.vue?vue&type=script&lang=js&"
export * from "./inputFile.vue?vue&type=script&lang=js&"
import style0 from "./inputFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports